import {IMachineDTO, MachineGroupType} from 'api/api';
import {FC, memo} from 'react';
import {LaserStatistics} from './laser-statistics';
import {MccStatistics} from './mcc-statistics';
import {PWStatistics} from './pw-statistics';
import {StandardStatistics} from './standard-statistics';

export interface StatisticsProps {
  machine?: IMachineDTO;
}

export const Statistics: FC<StatisticsProps> = memo(({machine}) => {
  switch (machine?.machineGroupType) {
    case MachineGroupType.Standard:
      return <StandardStatistics machine={machine} />;
    case MachineGroupType.PW:
      return <PWStatistics machine={machine} />;
    case MachineGroupType.Laser:
      return <LaserStatistics machine={machine} />;
    case MachineGroupType.MCC:
      return <MccStatistics machine={machine} />;
    default:
      return <></>;
  }
});
